import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const fetchGeolocation: DocumentNode = gql`
  query FetchGeolocation($type: String) {
    fetchGeocode(type: $type) {
      ... on GeocodeResponse {
        results {
          addressComponents {
            longName
            shortName
            types
          }
          types
          geometry {
            location {
              lat
              lng
            }
          }
        }
      }
    }
  }
`

export default fetchGeolocation
